import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import usePrivateLink from "../config/usePrivateLink";
import { studentFeeReceipt } from "../../api/Student";
import { useLocation } from "react-router-dom";
import { printElement, printImg } from "../master/Print";
import FeeReceipt1 from "../components/FeeReceipt1";

export default function StudentFeeReceipt() {
  usePrivateLink();

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const [data, setData] = useState({});

  const getData = async () => {
    setLoading(true);
    try {
      const response = await studentFeeReceipt(id);
      if (response.data.status) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <div className="col-6">
                    <h3>Fee Receipt</h3>
                  </div>
                  <div className="col-6 text-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => printImg("PrintDiv")}
                    >
                      Print
                    </button>
                  </div>
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <FeeReceipt1 data={data} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
